import { createViewerAction } from "../../core/make-action";
import ViewerMethod from "../../core/ViewerMethod";
import { getISBN } from "../viewer/selectors";
import {
  hasPreviousContentDoc as hasPreviousDoc,
  hasNextContentDoc as hasNextDoc,
} from "./selectors";

export const hasNextContentDoc = createViewerAction(
  ViewerMethod.HAS_NEXT_CONTENT_DOC
);
export const hasPreviousContentDoc = createViewerAction(
  ViewerMethod.HAS_PREVIOUS_CONTENT_DOC
);
const goToNextPageBase = createViewerAction(ViewerMethod.GO_TO_NEXT_PAGE);
export const goToNextPageBreak = createViewerAction(
  ViewerMethod.GO_TO_NEXT_PAGE_BREAK
);
const goToPrevPageBase = createViewerAction(ViewerMethod.GO_TO_PREV_PAGE);
export const goToPrevPageBreak = createViewerAction(
  ViewerMethod.GO_TO_PREV_PAGE_BREAK
);
export const goToPage = createViewerAction(ViewerMethod.GO_TO_PAGE);
export const goToURL = createViewerAction(ViewerMethod.GO_TO_URL);
export const goToCFI = createViewerAction(ViewerMethod.GO_TO_CFI);
export const registerPOI = createViewerAction(ViewerMethod.REGISTER_POI);

export const fetchUniversalURL = createViewerAction(
  ViewerMethod.GET_UNIVERSAL_URL
);

export function goToNextPage() {
  return function (dispatch, getState) {
    if (hasNextDoc(getState())) {
      dispatch(goToNextPageBase());
    }
  };
}

export function goToPrevPage() {
  return function (dispatch, getState) {
    if (hasPreviousDoc(getState())) {
      dispatch(goToPrevPageBase());
    }
  };
}

export function goToRecentPage() {
  return function (dispatch, getState) {
    const isbn = getISBN(getState());
    dispatch(goToURL(`/books/${isbn}/pages/recent`));
  };
}

export function goToFirstPage() {
  return function (dispatch, getState) {
    const isbn = getISBN(getState());
    dispatch(goToURL(`/books/${isbn}/pages/first`));
  };
}
